/** Base64 encoded string which returns multiple query parameter nonces and app id */
export const decode3dsCbpayQuery = (cbpay_query?: string | null) => {
  if (!cbpay_query) return undefined;
  const parsedQueryString = Buffer.from(cbpay_query, 'base64').toString();
  return new URLSearchParams(`?${parsedQueryString}`);
};
